import classes from "./classes.module.scss";
import classNames from "classnames";

export type IProps = {
	leftLabel: string;
	rightLabel: string;
	selected: "left" | "right";
	onChange: (selected: "left" | "right") => void;
	disabled?: boolean;
	className?: string;
};

export default function ToggleSwitch(props: IProps) {
	const { leftLabel, rightLabel, selected, onChange, disabled = false, className } = props;

	const handleLeftClick = () => {
		if (!disabled && selected !== "left") {
			onChange("left");
		}
	};

	const handleRightClick = () => {
		if (!disabled && selected !== "right") {
			onChange("right");
		}
	};

	return (
		<div className={classNames(classes["root"], disabled && classes["disabled"], className)}>
			<div className={classNames(classes["option"], selected === "left" && classes["selected"])} onClick={handleLeftClick}>
				{leftLabel}
			</div>
			<div className={classNames(classes["option"], selected === "right" && classes["selected"])} onClick={handleRightClick}>
				{rightLabel}
			</div>
		</div>
	);
}
